import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center m-2" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "z-40 absolute left-0 top-0 w-full h-full bg-black bg-gray-600 bg-opacity-70 items-center flex justify-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "w-full text-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  class: "mb-3 block text-gray-600 text-sm underline",
  href: "https://docs.giftee.biz/business/downloads/mileage_FAQ.pdf",
  target: "_blank",
  rel: "noopener noreferrer"
}, "カメラが立ち上がらない場合", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["src"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-secondary-700" }
const _hoisted_11 = { class: "text-secondary-700 mx-auto mt-4 w-4/5 align-center text-center" }
const _hoisted_12 = { class: "text-left" }
const _hoisted_13 = { class: "text-center w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReceiptUploadingNote = _resolveComponent("ReceiptUploadingNote")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_CardWithTitle = _resolveComponent("CardWithTitle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.uploadingGifVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", { src: _ctx.uploadingGif }, null, 8, _hoisted_4)
          ])
        ]))
      : (_openBlock(), _createBlock(_component_CardWithTitle, {
          key: 1,
          title: _ctx.cameraShootingMethodTitle,
          class: "sm:w-6/12 flex flex-col items-center text-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ReceiptUploadingNote),
            _createElementVNode("form", {
              method: "post",
              class: "m-0 w-full",
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.postChargeRequestReceiptCharging && _ctx.postChargeRequestReceiptCharging(...args)), ["prevent"]))
            }, [
              _createVNode(_component_BaseButton, {
                type: "button",
                class: "w-4/5 mt-5 mb-2",
                buttonClass: "main"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("label", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_ctx.activeCameraButtonLabel) + " ", 1),
                    _createElementVNode("input", {
                      type: "file",
                      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChangeReceiptImage && _ctx.onChangeReceiptImage(...args))),
                      style: {"display":"none"},
                      accept: "image/*",
                      capture: "camera",
                      required: ""
                    }, null, 32)
                  ])
                ]),
                _: 1
              }),
              _hoisted_6,
              (_ctx.imagePreviewUrl)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("img", {
                      src: _ctx.imagePreviewUrl,
                      class: "w-2/5 text-center mx-auto my-2"
                    }, null, 8, _hoisted_8),
                    (_ctx.declarationAmountRequired)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.declarationAmountDescription), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.declarationAmount) = $event)),
                            min: "1",
                            class: "h-8 w-4/5 px-2 m-2 text-s bg-white rounded-lg border-primary-main border text-gray-800",
                            required: ""
                          }, null, 512), [
                            [_vModelText, _ctx.declarationAmount]
                          ]),
                          _createTextVNode(_toDisplayString(_ctx.declarationAmountUnit) + " ", 1),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.photoConfirmation), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_BaseButton, {
                      class: "w-4/5 my-3",
                      buttonClass: "main"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.uploadPhotoButtonLabel), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ], 32)
          ]),
          _: 1
        }, 8, ["title"]))
  ]))
}